export enum SurveyTarget {
  Candidate = 'candidate',
  Interviewer = 'interviewer',
  HiringManager = 'hiring_manager',
  Employee = 'employee',
}
